export enum QwepProductEnum {
    ASSISTANT = 'ASSISTANT',
    BASKET = 'BASKET',
    ORDERS = 'ORDERS',
    PRICE = 'PRICE',
    BATCH_PRICE = 'BATCH_PRICE',
    SHOW_PROMOTION_ASSISTANT = 'SHOW_PROMOTION_ASSISTANT',
    WITHOUT_LITE = 'WITHOUT_LITE',
}
